document.addEventListener("DOMContentLoaded", function () {
  // === Header scroll effect ===
  var h = document.querySelector(".site-header");
  if (h) {
    window.addEventListener("scroll", function () {
      h.classList.toggle("scrolled", window.scrollY > 50);
    });
  }

  // === Mobile menu toggle ===
  var mobileToggle = document.querySelector(".mobile-toggle");
  var mobileMenu = document.querySelector(".mobile-menu");
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener("click", function () {
      mobileMenu.classList.toggle("open");
    });
  }

  // === Varied Scroll Animations ===
  var animateElements = document.querySelectorAll("[data-animate]");

  function handleScrollAnimations() {
    var viewportHeight = window.innerHeight;
    animateElements.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var inView = rect.top < viewportHeight * 0.88 && rect.bottom > 0;
      if (inView && !el.classList.contains("animated")) {
        el.classList.add("animated");
      }
    });
  }

  if (animateElements.length > 0) {
    handleScrollAnimations();
    window.addEventListener("scroll", handleScrollAnimations, { passive: true });
  }

  // === Product Page: Thumbnail gallery ===
  var thumbs = document.querySelectorAll(".product-thumb");
  var mainImg = document.getElementById("main-img");
  if (thumbs.length > 0 && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        thumbs.forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
        mainImg.src = thumb.getAttribute("data-img-url");
      });
    });
  }

  // === Product Page: Size/Color selectors ===
  var sizeButtons = document.querySelectorAll(".size-btn");
  sizeButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.parentElement;
      group.querySelectorAll(".size-btn").forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
      updateVariant();
    });
  });

  var colorButtons = document.querySelectorAll(".color-btn");
  colorButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.parentElement;
      group.querySelectorAll(".color-btn").forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
      updateVariant();
    });
  });

  // Update variant based on selected options + swap image
  function updateVariant() {
    var selectedOptions = [];
    document.querySelectorAll(".product-option-group").forEach(function (group) {
      var activeBtn = group.querySelector(".size-btn.active, .color-btn.active");
      var selectEl = group.querySelector(".product-option-select");
      if (activeBtn) {
        selectedOptions.push(activeBtn.getAttribute("data-value"));
      } else if (selectEl) {
        selectedOptions.push(selectEl.value);
      }
    });

    var variantSelect = document.getElementById("product-variant-select");
    if (!variantSelect) return;

    var options = variantSelect.querySelectorAll("option");
    options.forEach(function (option) {
      var optionData = JSON.parse(option.getAttribute("data-options") || "[]");
      var match = selectedOptions.every(function (val, i) { return optionData[i] === val; });
      if (match) {
        variantSelect.value = option.value;
        var addBtn = document.getElementById("add-to-cart-btn");
        if (option.getAttribute("data-available") === "false") {
          addBtn.textContent = "Sold Out";
          addBtn.disabled = true;
        } else {
          addBtn.textContent = "Add to Cart";
          addBtn.disabled = false;
        }

        // === COLOR-VARIANT IMAGE SWITCHING ===
        var variantImgUrl = option.getAttribute("data-image-url");
        var mainImgEl = document.getElementById("main-img");
        if (variantImgUrl && mainImgEl) {
          mainImgEl.src = variantImgUrl;
          // Also highlight the matching thumbnail
          var allThumbs = document.querySelectorAll(".product-thumb");
          allThumbs.forEach(function (t) {
            t.classList.remove("active");
            if (t.getAttribute("data-img-url") === variantImgUrl) {
              t.classList.add("active");
            }
          });
        }
      }
    });
  }

  // Option select change
  var optionSelects = document.querySelectorAll(".product-option-select");
  optionSelects.forEach(function (sel) {
    sel.addEventListener("change", updateVariant);
  });

  // === Quantity buttons ===
  var qtyMinus = document.getElementById("qty-minus");
  var qtyPlus = document.getElementById("qty-plus");
  var qtyInput = document.getElementById("qty-input");

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener("click", function () {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener("click", function () {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // === Cart Quantity Buttons ===
  document.querySelectorAll(".cart-qty-minus").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-key");
      var input = document.querySelector('.cart-qty-input[data-key="' + key + '"]');
      if (input) {
        var val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          updateCartItem(key, val - 1);
        }
      }
    });
  });

  document.querySelectorAll(".cart-qty-plus").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-key");
      var input = document.querySelector('.cart-qty-input[data-key="' + key + '"]');
      if (input) {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        updateCartItem(key, val + 1);
      }
    });
  });

  function updateCartItem(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () {
      window.location.reload();
    });
  }

  // === Product Filters ===
  var filterBtns = document.querySelectorAll(".filter-btn");
  var productsGrid = document.getElementById("products-grid");
  var activeFiltersEl = document.getElementById("active-filters");
  var activeFilterName = document.getElementById("active-filter-name");
  var clearFilterBtn = document.getElementById("clear-filter");
  var noProductsMsg = document.getElementById("no-products-msg");

  if (filterBtns.length > 0 && productsGrid) {
    filterBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        filterBtns.forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");

        var filter = btn.getAttribute("data-filter");
        var cards = productsGrid.querySelectorAll(".product-card");
        var visibleCount = 0;

        cards.forEach(function (card) {
          var type = card.getAttribute("data-product-type") || "";
          if (filter === "all" || type.toLowerCase().indexOf(filter.toLowerCase()) > -1) {
            card.style.display = "";
            visibleCount++;
          } else {
            card.style.display = "none";
          }
        });

        if (filter !== "all" && activeFiltersEl && activeFilterName) {
          activeFiltersEl.style.display = "flex";
          activeFilterName.textContent = btn.textContent;
        } else if (activeFiltersEl) {
          activeFiltersEl.style.display = "none";
        }

        if (noProductsMsg) {
          noProductsMsg.style.display = visibleCount === 0 ? "block" : "none";
        }
      });
    });

    if (clearFilterBtn) {
      clearFilterBtn.addEventListener("click", function () {
        filterBtns.forEach(function (b) { b.classList.remove("active"); });
        filterBtns[0].classList.add("active");
        productsGrid.querySelectorAll(".product-card").forEach(function (card) {
          card.style.display = "";
        });
        if (activeFiltersEl) activeFiltersEl.style.display = "none";
        if (noProductsMsg) noProductsMsg.style.display = "none";
      });
    }
  }

  // === Cart Note auto-save ===
  var cartNote = document.getElementById("cart-note");
  if (cartNote) {
    var noteTimeout;
    cartNote.addEventListener("input", function () {
      clearTimeout(noteTimeout);
      noteTimeout = setTimeout(function () {
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: cartNote.value })
        });
      }, 500);
    });
  }

  // === Nav dropdown hover ===
  var dropdownParent = document.querySelector(".nav-dropdown-parent");
  if (dropdownParent) {
    dropdownParent.addEventListener("mouseenter", function () {
      this.querySelector(".nav-dropdown").classList.add("open");
    });
    dropdownParent.addEventListener("mouseleave", function () {
      this.querySelector(".nav-dropdown").classList.remove("open");
    });
  }

  // === Mobile submenu toggle ===
  var mobileSubmenuToggle = document.querySelector(".mobile-submenu-toggle");
  if (mobileSubmenuToggle) {
    mobileSubmenuToggle.addEventListener("click", function (e) {
      e.preventDefault();
      this.parentElement.querySelector(".mobile-submenu").classList.toggle("open");
    });
  }

  // === Photo gallery marquee pause on hover ===
  var galleryTrack = document.querySelector(".gallery-track");
  if (galleryTrack) {
    galleryTrack.addEventListener("mouseenter", function () {
      this.style.animationPlayState = "paused";
    });
    galleryTrack.addEventListener("mouseleave", function () {
      this.style.animationPlayState = "running";
    });
  }
});
